import { Link } from "react-router-dom";
import styles from "../styles/Home.module.css";

import Header from "../components/Header";
import ProductOverview from "../components/ProductOverview";
import QuickInfo from "../components/QuickInfo";
import Button from "../components/Button";

export default function Home() {
  return (
    <>
      <Header
        title="I build high-quality apps for learning and data."
        subtitle={
          <>
            Creating apps for music education and{" "}
            <strong>Salesforce record quality</strong>.
          </>
        }
      >
        {" "}
        <div className={styles.actions}>
          <Button variant="btnMusic" size="btnWide" href="/products#note-ninja">
            Explore Note Ninja
          </Button>

          <Button
            variant="btnData"
            size="btnWide"
            href="/products#record-health"
          >
            Explore Record Health
          </Button>
        </div>
        <Link to="/contact" className={styles.contact}>
          Contact
        </Link>
      </Header>
      <ProductOverview />
      <QuickInfo />
    </>
  );
}
